import { EventTicketInfo } from 'core/Components';
import { BASE_URL } from 'core/Utils';
import { DateTime } from 'luxon';
import { ConsumerRedeemableTicket } from 'store/Api';

type MakeTicketInfo = EventTicketInfo & {
  eventTitle: string;
  eventThumbnail?: string;
  eventDateTitle: string;
  cartId?: string;
};

type makeTicketInfo = (ticket?: ConsumerRedeemableTicket) => MakeTicketInfo | null;
export const makeTicketInfo: makeTicketInfo = (ticket) => {
  if (!ticket) {
    return null;
  }

  const TICKETS_PATH = '/tickets';

  // Added ticket_id to ticketShareUrl - safe change
  const ticketShareUrl = `${BASE_URL}${TICKETS_PATH}/${ticket?.uuid}?cart_id=${ticket?.cart_id}&ticket_id=${ticket?.uuid}`;

  return {
    eventThumbnail:
      ticket?.store_item?.store_item?.images && ticket?.store_item?.store_item?.images[0]?.url,
    eventTitle: ticket?.store_item?.store_item?.name,
    eventDateTitle: ticket?.event_date?.title,
    title: ticket?.store_item?.store_item?.name,
    eventStartDate: ticket?.event_date?.starting_at,
    venueName: ticket?.store_item?.store_item?.location?.venue_name,
    addressLineOne: ticket?.store_item?.store_item?.location?.address1,
    addressLineTwo: ticket?.store_item?.store_item?.location?.address2,
    city: ticket?.store_item?.store_item?.location?.city,
    state: ticket?.store_item?.store_item?.location?.state,
    zipCode: ticket?.store_item?.store_item?.location?.zip_code,
    ticketId: ticket?.uuid,
    ticketName: ticket?.store_item?.name,
    isExpired: DateTime.now() > DateTime.fromISO(ticket?.expires_at),
    isUsed: !!ticket?.fulfilled_at,
    isDeleted: !!ticket?.deleted_at,
    ticketUrl: ticketShareUrl,
    ticketQrCodeUrl: ticketShareUrl,
    cartId: ticket?.cart_id,
  };
};
